import { ErsVariant }        from '@app/modules/ers/models/ers.model';
import { ErsState }          from '@app/modules/ers/store/ers.state';
import { adapterSelectors }  from '@core/store/adapter/adapter.selectors';
import { apiSelectors }      from '@core/store/api/api.selectors';
import { EntityVariantEnum } from '@models/entity.model';
import { EntityAdapter }     from '@ngrx/entity';
import {
	createFeatureSelector,
	createSelector
}                            from '@ngrx/store';
import { LoggerService }     from '@shared/services/logger.service';


export function ersSelector(
	adapter: EntityAdapter<ErsVariant>,
	storeId: string,
	logger: LoggerService
) {
	const ersStateSelector = createFeatureSelector<ErsState>( storeId );
	const adapterSelector = { ...adapterSelectors<ErsVariant, ErsState>( adapter, ersStateSelector ) };


	return {
		adapterSelector,
		...apiSelectors<ErsVariant, ErsState>( adapter, adapterSelector ),

		selectErsById: ( ersId: string ) =>
			createSelector(
				adapterSelector?.all,
				( ersList: ErsVariant[] ) => ersList.find( ( ers: ErsVariant ) => ers.id === ersId )
			),

		selectERSByBusinessPremisesId: ( businessPremisesId: string, entityVariant?: EntityVariantEnum ) =>
			createSelector(
				adapterSelector?.all,
				( ersList: ErsVariant[] ) =>
					ersList.filter( ( ers: ErsVariant ) => {
						const isMatchByBusinessPremisesId = ers.businessPremisesId === businessPremisesId;
						const isMatchByEntityVariant = entityVariant ? ers.entityVariant === entityVariant : true;

						return isMatchByBusinessPremisesId && isMatchByEntityVariant;
					} )
			),

		selectErsByIdAndEntityVariant: ( ersId: string, entityVariant: EntityVariantEnum ) =>
			createSelector(
				adapterSelector?.all,
				( ersList: ErsVariant[] ) => ersList.find( ( ers: ErsVariant ) => ers.id === ersId && ers.entityVariant === entityVariant )
			),

		selectErsListByEntityVariant: ( entityVariant: EntityVariantEnum ) =>
			createSelector(
				adapterSelector?.all,
				( ersList: ErsVariant[] ) => ersList.filter( ( ers: ErsVariant ) => ers.entityVariant === entityVariant )
			)
	};
}

